import TextField from '@mui/material/TextField';

const FromTextField = ({
  helperText = "",
  onChange = (event: any) => { onChange(event); }
}) => (
  <TextField id="tfTorihikisakimei"
    label="取引先名"
    size="small"
    //inputProps={{ maxLength: 7 }}
    onChange={(event: any) => { onChange(event); }}
    error={!!helperText}
    helperText={helperText}
  />
);

export default FromTextField;